export default __webpack_public_path__ + "static/media/flarum.118d557f.svg";